import {Component, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

import {LucideAngularModule} from 'lucide-angular';

@Component({
  selector: 'app-why-us',
  standalone: true,
  imports: [
    LucideAngularModule
  ],
  templateUrl: './why-us.component.html',
  styleUrl: './why-us.component.scss',
  animations: [
    trigger('fadeInUp', [
      state('void', style({
        opacity: 0,
        transform: 'translateY(30px)'
      })),
      transition('void => *', [
        animate('0.6s ease-out')
      ])
    ]),
    trigger('staggered', [
      transition('* => *', [
        style({opacity: 0, transform: 'translateY(30px)'}),
        animate('0.5s ease',
          style({opacity: 1, transform: 'translateY(0)'}))
      ])
    ])
  ]
})
export class WhyUsComponent implements OnInit {
  // Solid colors for the cards using specified colors with variations
  cardColors = [
    '#640DA9',  // Purple
    '#D420A4',  // Pink
    '#44A2FA',  // Blue
    '#E535B5',  // Pink variation (lighter)
    '#7B1BC7',  // Purple variation (lighter)
    '#C20F94',  // Pink variation (darker)
    '#2A8EF5',  // Blue variation (slightly darker)
    '#5928D1',  // Purple variation (more saturated)
    '#EC45C0'   // Pink variation (more saturated)
  ];
  reasons = [
    {
      icon: 'brain',
      title: 'Deep Matching Capabilities',
      description: 'Advanced AI analyzes every musical element - from melody to lyrics - for emotionally perfect matches.'
    },
    {
      icon: 'layers',
      title: 'Unparalleled Multi-modal Analysis',
      description: 'Combining visual, audio, and text analysis for the most precise matches.'
    },
    {
      icon: 'eye',
      title: 'Superior Context Recognition',
      description: 'Understanding the emotional context of visual content and how to best amplify it with a specific song segment.'
    },
    {
      icon: 'target',
      title: 'Specialized Market Focus',
      description: 'Built for Social media platforms, video and content creators.'
    },
    {
      icon: 'fingerprint',
      title: 'User Preference Fingerprinting',
      description: 'V2S\'s rich representation can fingerprint users\' implicit preferences for music, lyrics and sound.'
    },
    {
      icon: 'user',
      title: 'Personalization',
      description: 'Enhance matching based on demographic and behavioral data to deliver personalized, localized recommendations.'
    },
    {
      icon: 'zap',
      title: 'Seamless Onboarding',
      description: 'Fast API Integration for embedding V2S AI capabilities within consumer platforms.'
    },
    {
      icon: 'play',
      title: 'Real-time Automatic Matching',
      description: 'Suitable for live content at scale.'
    },
    {
      icon: 'shield',
      title: 'Privacy Aware',
      description: 'Designed to protect user privacy, does not require sensitive user data to be transmitted externally.'
    }
  ];

  visibleReasons: number[] = [];

  ngOnInit() {
    // Make all reasons immediately visible for hover effects,
    // then simulate staggered appearance animation
    for (let i = 0; i < this.reasons.length; i++) {
      this.visibleReasons.push(i);
    }
  }
}
